import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { TldrAction } from "../../../common/statelessView";
import TldrMediaTrimmingModal from "../../../common/TldrMediaTrimmingModal";
import { StyledTextEditorToolbarFormatGroup } from "../../../styled/details/stylesDetails";
import { batch } from "react-redux";
import styled from "styled-components";
import {
  setActiveLayer,
  setCrop,
  setVideoPlayingStatus,
} from "../../../../_actions/textToolbarActions";
import VideoEventHandler from "../../../canvas/handlers/VideoEventHandler";
import { wsTrimVideo } from "../../../../_actions/webSocketAction";
import { StyledTextEditorCustomActionButton } from "../../../styled/details/stylesDetails";
import { FaCut, FaPause, FaPlay, FaVolumeUp } from "react-icons/fa";
import {
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";
import ChakraVolumeSlider from "../../../../TldrStoryDetail/ExpandedMusicPlayerTimeline/ChakraVolumeSlider";

const VolumeSliderContainer = styled.div`
  height: 140px;
  width: 40px;
  background-color: #424242;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 12px 18px 18px;
  border-radius: 8px;
  z-index: 9999;
`;

class VideoEditorToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTrimmingModal: false,
    };
  }

  render() {
    const { activeElement, canvasRef, layerstore, t } = this.props;
    if (!activeElement.id) {
      return <></>;
    }
    const { showTrimmingModal } = this.state;
    let target = layerstore.layers[activeElement.id];

    return (
      <>
        {!this.props.isMobileView && <div className="tldr-vl" />}
        <StyledTextEditorToolbarFormatGroup>
          <TldrAction
            action={{}}
            icon={activeElement?.isVideoPlaying ? <FaPause /> : <FaPlay />}
            title={activeElement?.isVideoPlaying ? t("pause") : t("play")}
            userAction={{}}
            callback={this.playPause}
          />

          {/* <TldrAction
            action={activeElement.mime}
            icon={faCropAlt}
            title="Crop"
            callback={this.crop}
            disabled={activeElement.cropEnable}
          /> */}

          <TldrAction
            icon={<FaCut />}
            title={t("trim", { ns: "studio" })}
            callback={this.showTrimmingModal}
            disabled={activeElement.mime !== "video"}
          />
          {activeElement.mime === "video" && (
            <Popover>
              <PopoverTrigger>
                <StyledTextEditorCustomActionButton
                  icon={<FaVolumeUp />}
                  title={t("volume")}
                  callback={() => {}}
                  disabled={activeElement.mime !== "video"}
                >
                  <FaVolumeUp className="fa-16" />
                </StyledTextEditorCustomActionButton>
              </PopoverTrigger>
              <PopoverContent maxW="fit-content">
                <PopoverArrow />
                <VolumeSliderContainer>
                  <ChakraVolumeSlider
                    onChange={this.onChangeVolume}
                    value={
                      activeElement.format.muted
                        ? 0
                        : activeElement.format.volume * 100 || 100
                    }
                    variant="solid"
                  />
                </VolumeSliderContainer>
              </PopoverContent>
            </Popover>
          )}
        </StyledTextEditorToolbarFormatGroup>

        {target && showTrimmingModal && (
          <TldrMediaTrimmingModal
            show={showTrimmingModal}
            onHide={() => {
              this.setState({
                ...this.state,
                showTrimmingModal: false,
              });
            }}
            onSubmit={this.onTrimClick}
            mediaType={"Video"}
            canvasRef={canvasRef}
            data={target}
          />
        )}
      </>
    );
  }

  playPause = () => {
    const { canvasRef, t } = this.props;
    let video = this.selectedVideo();

    if (video.paused) {
      try {
        this.props.canvasRef.handler.startRequestAnimFrame();
        video.play();
      } catch (error) {
        console.error(`${t("errors.video_error", { ns: "common" })} ${error}`);
      }
    } else {
      video.pause();
    }
  };

  onTrimClick = ({ startTime, endTime, muted }) => {
    this.setState({
      ...this.state,
      showTrimmingModal: false,
    });

    const { canvasRef, wsTrimVideo } = this.props;
    const target = canvasRef.handler.canvas.getActiveObject();
    // target.set({ muted });
    target.setVideoPlaybackRange(startTime, endTime, muted);
    new VideoEventHandler(target, canvasRef.handler);
    canvasRef.handler.canvas.renderAll();
    wsTrimVideo(target.id, { startTime, endTime, muted });
  };

  onChangeVolume = (percentageVolume) => {
    const volume = percentageVolume / 100;
    const { canvasRef } = this.props;
    const target = canvasRef.handler.canvas.getActiveObject();
    target.setVolume(volume);
    new VideoEventHandler(target, canvasRef.handler);
    canvasRef.handler.canvas.renderAll();
    canvasRef.handler.set({ volume: volume });
  };

  crop = (action) => {
    const { canvasRef } = this.props;
    canvasRef.handler.cropHandler.start();

    let cropObject = canvasRef.handler.cropHandler.cropObject;
    batch(() => {
      this.props.setActiveLayer(
        cropObject.id,
        cropObject.type,
        cropObject,
        null
      );
      this.props.setCrop(true);
    });
  };

  selectedVideo = () => {
    const { canvasRef } = this.props;
    const target = canvasRef.handler.canvas.getActiveObject();

    if (!target || !target.element) {
      return;
    }

    return target.element;
  };

  showTrimmingModal = () => {
    this.setState({
      showTrimmingModal: true,
    });
  };
}

VideoEditorToolbar.propTypes = {
  activeElement: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
  layerstore: state.layerstore,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  setActiveLayer: (elementId, elementType, layerId, elementParentId) =>
    dispatch(setActiveLayer(elementId, elementType, layerId, elementParentId)),
  setCrop: (isEnable) => dispatch(setCrop(isEnable)),
  setVideoPlayingStatus: (isPlaying) =>
    dispatch(setVideoPlayingStatus(isPlaying)),
  wsTrimVideo: (layerId, payload) => dispatch(wsTrimVideo(layerId, payload)),
});

export default withTranslation(["common", "studio"])(
  connect(mapStateToProps, mapDispatchToProps)(VideoEditorToolbar)
);
